export default __webpack_public_path__ + "static/aws-icon-11-87c7b9a2b9d4e7add5c0947cb0922c7c.svg";